import { collection, onSnapshot } from "firebase/firestore";
import { createContext, useEffect, useState } from "react";

import { db } from "../../../BackEnd/Firebase/Config";

export const DataContext = createContext(null);

const DataContextProvider = ({ children }) => {
    const [products, setProducts] = useState([]);
    const [productsLoading, setProductsLoading] = useState(true);
    const [categories, setCategories] = useState([]);
    const [categoriesLoading, setCategoriesLoading] = useState(true);


    useEffect(() => {
        const unsubscribe = onSnapshot(collection(db, "products"), (snapshot) => {
            const updatedProducts = [];
            snapshot.forEach((doc) => {
                updatedProducts.push(doc.data());
            });
            setProducts(updatedProducts);
            setProductsLoading(false);
        }, (error) => {
            console.error("Error Fetching Products Data", error);
            setProductsLoading(false);
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        const unsubscribe = onSnapshot(collection(db, "categories"), (snapshot) => {
            const updatedCategories = [];
            snapshot.forEach((doc) => {
                updatedCategories.push(doc.data());
            });
            setCategories(updatedCategories);
            setCategoriesLoading(false);
        }, (error) => {
            console.error("Error Fetching Categories Data : ", error);
            setCategoriesLoading(false);
        });
        return () => unsubscribe();
    }, []);

    const contextvalue = {
        products, productsLoading, categories, categoriesLoading, setProductsLoading, setCategoriesLoading
    };

    return (
        <DataContext.Provider value={contextvalue} >
            {children}
        </DataContext.Provider>
    );
};

export default DataContextProvider;